<template>
  <v-card class="main" :disabled="admin.productImagesLoading">
    <v-card-text
      :style="isDragging && 'border-color: chartreuse;'"
      class="dropzone-container rounded-lg fileDropDiv my-4"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <v-progress-linear
        v-show="admin.productImagesLoading"
        indeterminate
        class="mb-2"
      />
      <input
        type="file"
        multiple="allowMultiple"
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        :accept="accept"
      />

      <label for="fileInput" class="file-label">
        <div v-if="isDragging" class="">Release to drop files here.</div>
        <div v-else class="fileDropDiv">
          Drop files here or <u>click here</u> to upload.
        </div>
      </label>
      <div class="preview-container mt-4" v-if="files.length">
        <div v-for="file in files" :key="file.name" class="preview-card">
          <div>
            <img class="preview-img" :src="generateURL(file)" />
            <p>
              {{ file.name }}
              {{ Math.round(file.size / 1000) + 'kb' }}
            </p>
          </div>
          <div>
            <v-btn
              color="red lighten-1"
              icon
              x-small
              class="ml-2"
              type="button"
              dark
              @click="remove(files.indexOf(file))"
              title="Remove file"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click="saveFiles" v-show="files.length > 0">
        <v-icon> mdi-check-bold </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      allowMultiple: {
        type: Boolean,
        default: true
      },
      accept: {
        type: String,
        default: '.pdf,.jpg,.jpeg,.png'
      },
      saveAction: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isDragging: false,
        files: []
      };
    },
    methods: {
      generateURL(file) {
        let fileSrc = URL.createObjectURL(file);
        setTimeout(() => {
          URL.revokeObjectURL(fileSrc);
        }, 1000);
        return fileSrc;
      },
      remove(i) {
        this.files.splice(i, 1);
      },
      onChange() {
        const self = this;
        let incomingFiles = Array.from(this.$refs.file.files);
        const fileExist = self.files.some((r) =>
          incomingFiles.some(
            (file) => file.name === r.name && file.size === r.size
          )
        );
        if (fileExist) {
          self.showMessage = true;
        } else {
          self.files.push(...incomingFiles);
        }
      },
      dragover(e) {
        e.preventDefault();
        this.isDragging = true;
      },
      dragleave() {
        this.isDragging = false;
      },
      drop(e) {
        e.preventDefault();
        this.$refs.file.files = e.dataTransfer.files;
        this.onChange();
        this.isDragging = false;
      },
      saveFiles() {
        console.log(this.saveAction);
        var fileObject = this.allowMultiple ? this.files : this.files[0];
        this.$store.dispatch(this.saveAction, fileObject).then(() => {
          this.files = [];
        });
      }
    },
    computed: {
      ...mapState(['app', 'admin'])
    }
  };
</script>

<style scoped>
  .fileDropDiv {
    width: 90%;
  }
  .main {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .dropzone-container {
    padding: 4rem;
    /* background: #f7fafc; */
    /* border: 1px solid #e2e8f0; */
    border: 2px solid;
    border-color: #9e9e9e;
  }

  .hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
  }

  .file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
  }

  .preview-container {
    display: flex;
    margin-top: 2rem;
  }

  .preview-card {
    display: flex;
    border: 1px solid #a2a2a2;
    border-radius: 4px;
    padding: 5px;
    margin-left: 5px;
  }

  .preview-img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #a2a2a2;
    background-color: transparent;
  }
</style>
